var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCombinedShape(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 15,
    viewBox: "0 0 20 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.3262 3.00823C19.1011 2.14348 18.4378 1.46252 17.5956 1.23141C16.0693 0.811402 9.94847 0.811401 9.94847 0.811401C9.94847 0.811401 3.82765 0.811402 2.30126 1.23141C1.45904 1.46252 0.795768 2.14348 0.570673 3.00823C0.161743 4.5755 0.161743 7.84561 0.161743 7.84561C0.161743 7.84561 0.161743 11.1156 0.570673 12.683C0.795768 13.5477 1.45904 14.2287 2.30126 14.4599C3.82765 14.8798 9.94847 14.8798 9.94847 14.8798C9.94847 14.8798 16.0693 14.8798 17.5956 14.4599C18.4378 14.2287 19.1011 13.5477 19.3262 12.683C19.7352 11.1156 19.7352 7.84561 19.7352 7.84561C19.7352 7.84561 19.7352 4.5755 19.3262 3.00823Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.1134 11.2092V5.09253L13.0068 8.151L8.1134 11.2092Z",
    fill: "#2B539F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCombinedShape);
export default __webpack_public_path__ + "static/media/Combined-Shape.2273f180858189b7a85039be4fd765cf.svg";
export { ForwardRef as ReactComponent };